// 方形角色图（mock 用，避免圆形徽章出现白底方块）
const roleImage = (seed) => `https://picsum.photos/seed/huaju-role-${seed}/600/600`;

/** 角色分类：与接口 cate 一致 1弟弟 2姐姐 3哥哥 4师娘 5师傅 */
export const TYPE_TABS = [
  { label: '弟弟', cate: 1 },
  { label: '姐姐', cate: 2 },
  { label: '哥哥', cate: 3 },
  { label: '师娘', cate: 4 },
  { label: '师傅', cate: 5 },
];

/** 配件分类：与接口 cate 一致 1衣服 2面具 3饰品 */
export const ACCESSORY_TABS = [
  { label: '衣服', cate: 1 },
  { label: '面具', cate: 2 },
  { label: '饰品', cate: 3 },
];

const roleSuffix = ['A', 'B', 'C', 'D'];

const roleList = TYPE_TABS.flatMap(({ label, cate }) =>
  roleSuffix.map((suffix, index) => ({
    goodsId: cate * 100 + index + 1,
    id: `role-${cate}-${suffix}`,
    nftNo: `HJ-R${cate}${suffix}`,
    collectionName: `禁忌的色彩-${label}${suffix}`,
    name: `禁忌的色彩-${label}${suffix}`,
    nftImage: roleImage(`${cate}-${suffix}`),
    imageUrl: roleImage(`${cate}-${suffix}`),
    itemType: 'role',
    type: 1,
    cate,
    roleType: cate,
    style: index + 1,
    ownedCount: index === 1 || index === 3 ? 2 : 1,
    count: index === 1 || index === 3 ? 2 : 1,
  })),
);

const accessoryGroups = [
  { cate: 1, prefix: '衣服', names: ['绣花披风', '戏服袖口', '金色腰带'] },
  { cate: 2, prefix: '面具', names: ['戏曲头饰', '红色脸谱', '蓝色脸谱'] },
  { cate: 3, prefix: '饰品', names: ['金色道具', '手持折扇', '绣花鞋'] },
];

const accessoryList = accessoryGroups.flatMap(({ cate, prefix, names }) =>
  names.map((name, index) => ({
    goodsId: 2000 + cate * 10 + index,
    id: `accessory-${cate}-${index}`,
    nftNo: `HJ-A${cate}${index + 1}`,
    collectionName: `禁忌-${prefix}${String.fromCharCode(65 + index)}`,
    name: `禁忌-${prefix}${String.fromCharCode(65 + index)}`,
    nftImage: roleImage(`acc-${cate}-${index}`),
    imageUrl: roleImage(`acc-${cate}-${index}`),
    itemType: 'accessory',
    type: 2,
    cate,
    accessoryType: cate,
    style: index + 1,
    ownedCount: index === 1 ? 2 : 1,
    count: index === 1 ? 2 : 1,
  })),
);

export const MOCK_COLLECTION_LIST = [...roleList, ...accessoryList];
